module.exports = __webpack_public_path__ + "img/2.a0081f3f.png";